// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { HarEntryDecodeStatusSchema } from '../inputTypeSchemas/HarEntryDecodeStatusSchema'

/////////////////////////////////////////
// WEB GRPC DECODED DATA SCHEMA
/////////////////////////////////////////

export const WebGrpcDecodedDataSchema = z.object({
  status: HarEntryDecodeStatusSchema,
  protocol: z.string(),
  methodPath: z.string(),
  decodedRequest: JsonValueSchema.nullable(),
  decodedResponse: JsonValueSchema.nullable(),
  grpcStatus: z.number().int().nullable(),
  grpcMessage: z.string().nullable(),
  error: z.string().nullable(),
  schemaChecksum: z.string(),
})

export type WebGrpcDecodedData = z.infer<typeof WebGrpcDecodedDataSchema>

export default WebGrpcDecodedDataSchema;
